import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.additional-info-read-more', () => {
  import('./internal/additional-info-read-more').then(({ default: Component }) => Component());
});
